<template>
    <div class="product-item d-flex flex-column">
        <div class="d-flex align-items-center">
            <div class="product-item-meta">
                <h2 class="product-item-title">{{ product.name }}</h2>
                <p class="product-item-summary" v-html="product.description"></p>
            </div>
            <div class="product-item-price ml-auto">
                {{ product.price | currency }}

                <button
                    @click="productClick()"
                    class="button button-icon"
                >
                    <icon icon="plus" />
                </button>
            </div>
        </div>

        <transition name="fade">
            <div
                v-if="product.showExtras"
                class="product-extras"
            >
                <ul v-if="product.dish_extras.length > 0" class="list">
                    <li
                        v-for="productExtra in product.dish_extras"
                        :key="productExtra.id"
                    >
                        <label>
                            <input
                                v-model="productExtra.selected"
                                type="checkbox"
                            >
                            {{ productExtra.name }}

                            <template v-if="productExtra.price !== 0">
                                (+ {{ productExtra.price | currency }})
                            </template>
                        </label>
                    </li>
                </ul>

                <div class="d-flex flex-column flex-sm-row justify-content-between">
                    <div class="product-item-quantity d-flex align-items-center justify-content-between justify-content-sm-start mb-3 mb-sm-0">
                        <button
                            @click="product.quantity -= 1"
                            class="button button-icon"
                            :disabled="product.quantity <= 1"
                        >
                            <icon icon="minus"/>
                        </button>
                        <p class="product-item-quantity-counter">{{ product.quantity }}</p>
                        <button
                            @click="product.quantity += 1"
                            class="button button-icon"
                        >
                            <icon icon="plus"/>
                        </button>
                    </div>
                    <button
                        @click="triggerAddToCart()"
                        class="button"
                    >
                        <icon icon="plus" />
                        Voeg toe ({{ productPrice | currency }})
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    import Icon from '@/components/ui/Icon';

    export default {
        name: 'Product',
        components: {
            Icon,
        },
        props: {
            productItem: {
                type: Object,
            },
        },
        data() {
            return {
                product: {},
            };
        },
        created() {
            this.product = Object.assign({}, { ...this.productItem, showExtras: false, quantity: 1 });
        },
        computed: {
            productPrice() {
                if (this.product.dish_extras.find(item => item.selected)) {
                    return (this.product.dish_extras
                        .filter(item => item.selected)
                        .map(item => item.price)
                        .reduce((a, b) => a + b, 0)
                        + this.product.price) * this.product.quantity;
                }

                return this.product.price * this.product.quantity;
            },
        },
        methods: {
            ...mapActions('cart', [
                'addToCart',
            ]),

            openExtras() {
                this.product.showExtras = true;
            },

            productReset() {
                this.product.dish_extras.forEach(item => item.selected = false); // eslint-disable-line
                this.product.showExtras = false;
                this.product.quantity = 1;
            },

            async productClick() {
                // Handles clicking the + on a product.
                // When the product has extras, the extra panel will be opened
                // Otherwise we will add it straight to the basket.

                if (this.product.dish_extras.length > 0) {
                    this.openExtras();
                } else {
                    await this.triggerAddToCart();
                }
            },

            async triggerAddToCart() {
                await this.addToCart(this.product);

                this.productReset();
            },
        },
    };
</script>
